import React from 'react';
import { FormattedMessage } from 'react-intl';
import ToastWrapper from '@/components/toasts/ToastWrapper';

const SubscriptionToast = ({ event, isSubscribed }) => (
  <ToastWrapper
    className="aridhia-subscription-toast"
    icon={isSubscribed ? 'eye' : 'eye slash'}
    color={isSubscribed ? 'green' : 'red'}
  >
    <FormattedMessage id={`events.${event}.${isSubscribed ? 'subscribe' : 'unsubscribe'}.toast`} />
  </ToastWrapper>
);

export default SubscriptionToast;
